import React, { useContext } from 'react';
import TimelineItem from '../TimelineItem/TimelineItem';
import getProfileData from '../../data/profileData';
import { LanguageContext } from '../../contexts/LanguageContext';
import styles from './Timeline.module.css';

const Timeline = () => {
  const { language } = useContext(LanguageContext);
  const { timelineEntries, timelineTitle } = getProfileData(language);

  return (
    <section className={styles.timeline}>
      <h2 className={styles.title} data-testid="timeline-title">{timelineTitle}</h2>
      <div className={styles.timelineContent}>
        {timelineEntries.map((entry, index) => (
          <TimelineItem
            key={index}
            period={entry.period}
            title={entry.title}
            role={entry.role}
            description={entry.description}
            links={entry.links}
          />
        ))}
      </div>
    </section>
  );
};

export default Timeline;